<template>
    <div class="modal fade" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Замовити консультацію</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <label class="font-weight-bold">ПІБ</label>
                    <input id="input-pib" type="text" class="form-control mb-4" placeholder="Наприклад: Петренко Дмитро Петрович">
                    <label class="font-weight-bold">Електронна пошта</label>
                    <input id="input-email" type="text" class="form-control mb-4" placeholder="Наприклад: petrenko@gmail.com">
                    <label class="font-weight-bold">Телефон</label>
                    <input id="input-phone" type="text" class="form-control mb-4" placeholder="Телефон">
                </div>
                <div class="modal-footer">
                    <button id="submit-form" data-dismiss="modal" type="button" class="btn btn-success">Відправити</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import $ from "jquery";
    import "gasparesganga-jquery-loading-overlay";
    import Inputmask from "inputmask";
    import Noty from "noty";

    export default {
        name: "Modal",
        mounted() {

            var im = new Inputmask("+38 (999) 999-99-99", {
                placeholder: "+38 (___) ___-__-__",
                clearMaskOnLostFocus: false
            });

            im.mask("#input-phone");


            $("#open-modal").click(function () {
                $(".modal").modal("show");
            });

            $("#submit-form").click(function () {

                $.LoadingOverlay("show", {
                    imageColor: "#AD2A2C"
                });

                $.post("handler.php", {
                    pib: $("#input-pib").val(),
                    email: $("#input-email").val(),
                    phone: $("#input-phone").val(),
                }, function (resp) {

                    $.LoadingOverlay("hide");

                    if (resp.error) {
                        new Noty({
                            theme: "metroui",
                            type: "error",
                            text: resp.message,
                            timeout: 5000
                        }).show();
                    } else {
                        new Noty({
                            theme: "metroui",
                            type: "success",
                            text: "Заявка відправлена. Наші менеджери звьяжуться з вами у найближчій час.",
                            timeout: 5000
                        }).show();
                    }
                }, "json");
            });
        }
    }
</script>

<style lang="less" scoped>

    @import "../../node_modules/noty/lib/noty.css";
    @import "../../node_modules/noty/lib/themes/metroui.css";

</style>